import { router } from '@inertiajs/svelte'
import type { PendingVisit } from '@inertiajs/core'
import { readable } from 'svelte/store'

// One subscription shared by the responsive headers; it also survives a
// header mounting while another is still displaying the current navigation.
export const navigationLoading = readable(false, (set) => {
  let activeVisit: PendingVisit | null = null
  let timeout: ReturnType<typeof setTimeout> | undefined

  function reset() {
    clearTimeout(timeout)
    timeout = undefined
    activeVisit = null
    set(false)
  }

  const removeStart = router.on('start', ({ detail: { visit } }) => {
    if (
      visit.method !== 'get' ||
      visit.async ||
      visit.prefetch ||
      !visit.showProgress
    )
      return

    reset()
    activeVisit = visit
    timeout = setTimeout(() => set(true), 300)
  })

  const removeFinish = router.on('finish', ({ detail: { visit } }) => {
    // Background requests and interrupted visits must not hide a newer visit.
    // Inertia emits finish for success, errors, network failures and cancellation.
    if (visit === activeVisit) reset()
  })

  return () => {
    removeStart()
    removeFinish()
    reset()
  }
})
